import { render, staticRenderFns } from "./ConfigureTestForm.vue?vue&type=template&id=8d9a8a2c"
import script from "./ConfigureTestForm.vue?vue&type=script&lang=js"
export * from "./ConfigureTestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports